import { CommonUIEvents } from "@gluckgames/commonui";
import { ButtonEvent } from "appworks/graphics/elements/button-element";
import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { Model } from "appworks/model/model";
import { Services } from "appworks/services/services";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { normalizeIndex } from "appworks/utils/collection-utils";
import { gamevy } from "gamevy/gamevy";

enum SpeedModes {
    Normal = 0,
    Quick = 1,
    Turbo = 2
}

export class GamevySpeedControl extends AbstractControl {
    protected buttons: FlexiButton[];

    constructor(normalButton: FlexiButton, quickButton: FlexiButton, turboButton: FlexiButton) {
        super();

        this.buttons = [normalButton, quickButton, turboButton];
        for (const button of this.buttons) {
            button.on(ButtonEvent.CLICK, this.onClick);
        }

        this.refreshButtons(true);
        gamevy.commonUI.on(
            CommonUIEvents.CHANGE_AUTOSPIN_SETTINGS,
            this.onChangeAutospinSettings
        );
    }

    public destroy(): void {
        super.destroy();

        for (const button of this.buttons) {
            button.off(ButtonEvent.CLICK, this.onClick);
        }

        gamevy.commonUI.off(
            CommonUIEvents.CHANGE_AUTOSPIN_SETTINGS,
            this.onChangeAutospinSettings
        );
    }

    public setVisible(visible: boolean): void {
        this.refreshButtons(visible);
    }

    public setEnabled(enabled: boolean): void {
        this.buttons.forEach((button, index) => {
            button.setEnabled(enabled);
        });
        super.setEnabled(enabled);
        this.setVisible(true);
    }

    protected onChangeAutospinSettings = () => {
        this.refreshButtons(true);
    }

    protected onClick = () => {
        const speedIndex: SpeedModes = normalizeIndex(
            this.getSpeedIndex() + 1,
            Object.keys(SpeedModes).filter((x) => isNaN(Number(x)))
        );

        const quickSpin = speedIndex === SpeedModes.Quick;
        const turboSpin = speedIndex === SpeedModes.Turbo;
        Model.write({ settings: { quickSpin, turboSpin } });

        this.refreshButtons(true);
    }

    protected refreshButtons(visible: boolean) {
        const allowQuickSpin = Services.jurisdiction.getQuickSpinEnabled();
        this.buttons.forEach((button, index) => {
            button.setVisible(visible && allowQuickSpin && index === this.getSpeedIndex());
        });
    }

    protected getSpeedIndex(): SpeedModes {
        const { quickSpin, turboSpin } = Model.read().settings;
        if (turboSpin) {
            return SpeedModes.Turbo;
        } else if (quickSpin) {
            return SpeedModes.Quick;
        } else {
            return SpeedModes.Normal;
        }
    }
}
